export default __webpack_public_path__ + "static/media/Athlone.809e35cf.otf";